import React from 'react'

const Excel = ({ handleExport }) => {
  return (
    <div>
        <button className='c-b-btn d-flex align-items-center gap-2' onClick={() => handleExport()}>
          <img src="/assets/images/excel-logo.svg" alt="" /> Excel
        </button>
    </div>
  )
}

export default Excel
